import dayjs from "dayjs";

const month = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
];

const monthMM = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];

const thaiDateToDate = (date) => {
    const [d, m, y] = date.split(" ")
    const month = monthJson.find(x => x.month_th === m)
    if (month === undefined) return undefined
    return dayjs(`${d} ${month.month_num} ${y - 43}`, "DD M YY")
}

const monthJson = [
    {
        "month_en": "Jan",
        "month_th": "ม.ค.",
        "month_num": 1
    },
    {
        "month_en": "Feb",
        "month_th": "ก.พ.",
        "month_num": 2
    },
    {
        "month_en": "Mar",
        "month_th": "มี.ค.",
        "month_num": 3
    },
    {
        "month_en": "Apr",
        "month_th": "เม.ษ.",
        "month_num": 4
    },
    {
        "month_en": "May",
        "month_th": "พ.ค.",
        "month_num": 5
    },
    {
        "month_en": "Jun",
        "month_th": "มิ.ย.",
        "month_num": 6
    },
    {
        "month_en": "Jul",
        "month_th": "ก.ค.",
        "month_num": 7
    },
    {
        "month_en": "Aug",
        "month_th": "ส.ค.",
        "month_num": 8
    },
    {
        "month_en": "Sep",
        "month_th": "ก.ย.",
        "month_num": 9
    },
    {
        "month_en": "Oct",
        "month_th": "ต.ค.",
        "month_num": 10
    },
    {
        "month_en": "Nov",
        "month_th": "พ.ย.",
        "month_num": 11
    },
    {
        "month_en": "Dec",
        "month_th": "ธ.ค.",
        "month_num": 12
    },
]

export { month, monthMM, monthJson, thaiDateToDate };
